<template>
  <PageBreadcrumbs :items="breadcrumbs" />
  <ContentCard>
    <template #header>
      <ContentCardSubheader>
        {{ t('Reviews.agency.view.preferencesTitle', { agencyName: agency.title }) }}
        <template #actions>
          <RouterLink
            class="btn-primary-color-s"
            data-testid="agency-pref-edit"
            :to="{ name: ReviewsRouteName.ReviewsAgencyPreferencesEdit, params: { agencyId: agency.id } }"
            @click="track('profile_update_start', { surface: 'editor', entity_type: 'service', entity_id: agency.id })"
          >
            {{ t('Reviews.edit.action.edit') }}
          </RouterLink>
        </template>
      </ContentCardSubheader>
    </template>
    <div class="flex flex-col gap-y-10 py-6">
      <PreferenceItem
        data-testid="agency-preferences-contact-emails"
        :items="agency.contactFormRecipients || []"
        :description="t('Reviews.agency.view.preferences.contactEmails.description')"
        :title="t('Reviews.agency.view.preferences.contactEmails.title')"
      />
    </div>
  </ContentCard>
  <IntegrationsCard v-if="agency.configFlags.pageVisitReportsEnabled" class="mt-6" entity-type="agency" />
</template>

<script setup lang="ts">
import { track } from '@ramp106/omrjs-tracking-reviews'
import { useI18n } from 'vue-i18n'

import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import IntegrationsCard from '@/components/ReviewsCommon/Integrations/IntegrationsCard.vue'
import PreferenceItem from '@/components/ReviewsManagement/Preferences/PreferenceItem.vue'
import { useReviewsAgencyBreadcrumbs } from '@/composables/breadcrumbs/useReviewsAgencyBreadcrumbs'
import type { AgencyData } from '@/gql/reviews'
import { ReviewsRouteName } from '@/router/types'
import ContentCard from '@/ui/ContentCard.vue'
import ContentCardSubheader from '@/ui/ContentCardSubheader.vue'

const props = defineProps<{
  agency: AgencyData
}>()

const { t } = useI18n()
const breadcrumbs = useReviewsAgencyBreadcrumbs(props.agency)
</script>
